<template>
    <div class="">
        <div class="w-full">
            <img
                v-if="currentImage && !isSmilesCurrent"
                :src="currentImage"
                class="w-full h-auto object-contain rounded-m"
                alt="Product Image"
            />
            <div
                v-else
                class="w-full h-96 flex items-center justify-center bg-grey-30 rounded-m"
            >
                <canvas class="w-full h-full" v-smiles="smiles"></canvas>
            </div>
        </div>

        <div
            class="mt-4 flex gap-3"
            v-if="(images && images.length > 1) || smiles"
        >
            <div
                class="p-3 shadow-md rounded-s"
                v-for="(image, index) in images"
                :key="index"
            >
                <img
                    :src="image"
                    class="w-auto h-24 object-contain cursor-pointer rounded-s"
                    :class="{ '': image === currentImage }"
                    @click="switchImage(image)"
                    alt="Thumbnail"
                />
            </div>
            <div
                class="p-3 shadow-md rounded-s flex items-center justify-center cursor-pointer"
                v-if="smiles && images.length > 0"
                @click="
                    isSmilesCurrent = true;
                    currentImage = null;
                "
            >
                <canvas class="w-24 h-16" v-smiles="smiles"></canvas>
            </div>
        </div>
    </div>
</template>

<script>
import { BASEURL } from "@libTs/cms.globals";
import { vSmiles } from "../directives/v-smiles";

export default {
    inject: [
        "cartSvc",
        "productsSvc",
        "watchlistSvc",
        "overlaysSvc",
        "itemSvc",
        "compareSvc",
    ],
    props: {
        images: {
            type: Array,
            required: true,
        },
        smiles: {
            type: String,
            required: false,
            default: null,
        },
    },
    directives: {
        smiles: vSmiles,
    },
    data() {
        return {
            currentImage: this.images[0] || null,
            isSmilesCurrent: this.images.length === 0 && this.smiles,
            baseUrl: BASEURL,
        };
    },
    methods: {
        switchImage(image) {
            this.currentImage = image;
        },
    },
};
</script>

<style scoped></style>
